@import 'fluid-in-page-nav.theme.less';

@import '../../../styles/mixins/fluid-media-queries.mixin.less';
@import '../../../styles/mixins/fluid-transitions.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  min-width: 250px;
  max-width: 400px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 15vw;

  *,
  ::after,
  ::before {
    box-sizing: border-box;
  }

  .fluid-in-page-nav {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../../styles/variables-iuw-legacy.less';
      @in-page-nav-tokens: @in-page-nav-tokens-legacy;
      @in-page-nav();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../../styles/variables-lm.less';
      @in-page-nav-tokens: @in-page-nav-tokens-lm;
      @in-page-nav();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp,
    &.default {
      @import '../../../styles/variables-lm-corp.less';
      @in-page-nav-tokens: @in-page-nav-tokens-corp;
      @in-page-nav();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../../styles/variables-lm-portal.less';
      @in-page-nav-tokens: @in-page-nav-tokens-portal;
      @in-page-nav();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@in-page-nav: {
  position: sticky;
  top: 0;
  font-family: @font-family; // Important - do not remove
  font-size: @font-size; // Important - do not remove
  line-height: @line-height; // Important - do not remove
  color: @color-text; // Optional - depends on the component's purpose
  overflow-y: auto;

  @media @screen-md-down {
    display: none;
  }

  // ==== Body

  .nav-body {
    padding-top: 2em;

    &.anchor-left {
      padding-left: 1em;
      padding-right: 0;
    }

    &.anchor-right {
      padding-left: 0;
      padding-right: 1em;
    }
  }

  // ==== Title

  .nav-list-title {
    margin-bottom: 1em;
  }
}
